import { Separator } from '@mc/design-system'

import Link from 'components/Link'
import Image from 'components/LegacyImage'
import { FeaturedArticle as FeaturedArticleInterface } from 'types/data'
import { articleCategoryPath, articlePath } from 'libs/paths'

import { formattedDate, truncate } from '../utils'
import { trackFeatureArticleEvent } from '../events'

export const FeaturedArticle = ({
  heading,
  featuredArticle,
}: {
  heading: string
  featuredArticle: FeaturedArticleInterface
}) => {
  const trackArticleClick = () => {
    trackFeatureArticleEvent({
      title: featuredArticle.title,
    })
  }

  return (
    <section className='container mc-py-9'>
      <h1 className='mc-text-h5 mc-mb-2'>{heading}</h1>
      <Separator className='mc-my-3' />
      <div className='row mc-py-9'>
        <div className='col-12 col-md-7 d-flex flex-column justify-content-center order-2'>
          <div className='row no-gutters'>
            <div className='col-11'>
              <Link
                className='mc-text-h8 mc-text--uppercase mc-opacity--muted'
                href={articleCategoryPath(featuredArticle.category.slug)}
                onClick={() =>
                  trackFeatureArticleEvent({
                    action: 'view-category',
                    category: featuredArticle.category.name,
                  })
                }
                passHref
              >
                {featuredArticle.category.name}
              </Link>
              <h3 className='mc-text-h1 mc-mt-1 mc-text--bare-link'>
                <Link
                  href={articlePath(featuredArticle.slug)}
                  onClick={trackArticleClick}
                  passHref
                >
                  {featuredArticle.title}
                </Link>
              </h3>
              <p className='mc-opacity--hinted mc-text-large mc-mt-2'>
                <Link
                  href={articlePath(featuredArticle.slug)}
                  onClick={trackArticleClick}
                  passHref
                >
                  {truncate(featuredArticle.description, 180)}
                </Link>
              </p>
              <p className='mc-opacity--muted mc-text-x-small mc-mt-2'>
                {formattedDate(featuredArticle.updatedAt)}
              </p>
            </div>
          </div>
        </div>
        <div className='col-12 col-md-5 order-1 order-md-2'>
          <div className='row no-gutters'>
            <Link
              href={articlePath(featuredArticle.slug)}
              onClick={trackArticleClick}
              passHref
            >
              <Image
                alt=''
                src={featuredArticle.heroImage.url}
                objectFit='cover'
                width={960}
                height={960}
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
